import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import HomeScreen from './screens/Public/Home';
import PropertyDetailsScreen from '@screens/Public/PropertyDetails';
import ContactScreen from '@screens/Public/Contact';
import NewCodeScreen from '@screens/Authenticated/Property/NewCodeScreen/NewCodeScreen';
import NewRegisterScreen from '@screens/Authenticated/Property/NewRegisterScreen/NewRegisterScreen';
import ViewRegisterScreen from '@screens/Authenticated/Property/NewRegisterScreen/ViewRegisterScreen';
import PropertyListScreen from '@screens/Authenticated/Property/PropertyListScreen/PropertyListScreen';
import FormContactScreen from '@screens/Authenticated/Clients/FormContact/FormContactScreen';
import PropertyRegisterScreen from '@screens/Authenticated/Clients/PropertyRegister/PropertyRegisterScreen';
import PropertyOrderScreen from '@screens/Authenticated/Clients/PropertyOrder/PropertyOrderScreen';
import UserListScreen from '@screens/Authenticated/Users/UserList/UserListScreen';
import ContactDetailScreen from '@screens/Authenticated/Clients/ContactDetailScreen/ContactDetailScreen';
import RegistrationFormDetailScreen from '@screens/Authenticated/Clients/PropertyOrder/RegistrationFormDetailScreen';
import OrderPropertyDetailScreen from '@screens/Authenticated/Clients/OrderPropertyDetails/OrderPropertyDetailScreen';
import UserRegisterScreen from '@screens/Authenticated/Users/UserRegisterScreen/UserRegisterScreen';
import UserEditScreen from '@screens/Authenticated/Users/UserEditScreen/UserEditScreen';
import RegisterPropertyScreen from '@screens/Public/RegisterPropertyScreen';
import OrderFormScreen from '@screens/Public/OrderFormScreen';
import LoginScreen from '@screens/Authenticated/Login/LoginScreen';
import RecoveryPassScreen from '@screens/Authenticated/RecoveryPass/RecoveryPassScreen';
import AccountScreen from '@screens/Authenticated/Account/AccountScreen';
import ConfigUsersScreen from '@screens/Authenticated/Config/Users/ConfigUsersScreen';
import ConfigUsersCreateScreen from '@screens/Authenticated/Config/UsersCreate/ConfigUsersCreateScreen';
import ConfigCategoriesScreen from '@screens/Authenticated/Config/Categories/ConfigCategoriesScreen';
import ConfigPropertyTypesScreen from '@screens/Authenticated/Config/PropertyTypes/ConfigPropertyTypesScreen';
import ConfigPropertyCodeScreen from '@screens/Authenticated/Config/PropertyCode/ConfigPropertyCodeScreen';
import ConfigServedCitiesScreen from '@screens/Authenticated/Config/ServedCities/ConfigServedCitiesScreen';
import ConfigCompanyDataScreen from '@screens/Authenticated/Config/CompanyData';
import ConfigKeysScreen from '@screens/Authenticated/Config/Keys/ConfigKeysScreen';
import ConfigConditionsScreen from '@screens/Authenticated/Config/Conditions/ConfigConditionsScreen';
import { useUserStore } from '@stores/User/User';
import { UserRole } from '@stores/User/types';
import { AtuthenticatedDetailsScreen } from '@screens/Authenticated/Property/AtuthenticatedDetailsScreen';
import DestaquesScreen from '@screens/Authenticated/Property/DestaquesScreen/DestaquesScreen';

const AppRoutes = () => {
  const { token, role } = useUserStore();
  const isAuthenticated = !!token;
  const isAdmin = role === UserRole.ADMIN;
  const isSecretaria = role === UserRole.SECRETARIA;
  const isCorretor = role === UserRole.CORRETOR;
  const canEdit = isAdmin || isSecretaria;
  return (
    <Routes>
      <Route path="/" element={<HomeScreen />} />
      <Route
        path="/pesquisar"
        element={
          <HomeScreen
            showCarousel={false}
            showOperationFilter={false}
            filterDirection="row"
          />
        }
      />
      <Route path="/home" element={<HomeScreen />} />
      <Route path="/imoveis/:propertyId" element={<PropertyDetailsScreen />} />
      <Route
        path="/imoveis/:propertyId/:propertyTitle"
        element={<PropertyDetailsScreen />}
      />
      <Route
        path="/pesquisar/:tipoImovel"
        element={
          <HomeScreen
            showCarousel={false}
            showOperationFilter={false}
            filterDirection="row"
          />
        }
      />
      <Route path="/cadastrar-imovel" element={<RegisterPropertyScreen />} />
      <Route path="/encomendar-imovel" element={<OrderFormScreen />} />
      <Route
        path="/venda"
        element={
          <HomeScreen
            defaultFilter="VENDA"
            showCarousel={false}
            showOperationFilter={false}
            filterDirection="row"
          />
        }
      />
      <Route
        path="/aluguel"
        element={
          <HomeScreen
            defaultFilter="ALUGUEL"
            showCarousel={false}
            showOperationFilter={false}
            filterDirection="row"
          />
        }
      />
      <Route path="/contato" element={<ContactScreen />} />
      <Route path="/login" element={<LoginScreen />} />
      <Route path="/recuperar-senha" element={<RecoveryPassScreen />} />

      {/* Area do Corretor*/}
      {isAuthenticated && (
        <>
          <Route path="/area-do-corretor" element={<PropertyListScreen />} />
          <Route path="/area-do-corretor/conta" element={<AccountScreen />} />
          <Route
            path="/area-do-corretor/imoveis/novo-cadastro"
            element={<NewRegisterScreen />}
          />
          <Route
            path="/area-do-corretor/imoveis/consultar/:id"
            element={<ViewRegisterScreen />}
          />
          {(canEdit || isCorretor) && (
            <Route
              path="/area-do-corretor/imoveis/editar/:id"
              element={<NewRegisterScreen />}
            />
          )}
          {(isAdmin || isSecretaria || isCorretor) && (
            <Route
              path="/area-do-corretor/imoveis/listagem/:listType"
              element={<PropertyListScreen />}
            />
          )}
          {isAdmin && (
            <>
              <Route
                path="/area-do-corretor/imoveis/adicionar-codigo"
                element={<NewCodeScreen />}
              />

              <Route
                path="/area-do-corretor/arquivos/:listType"
                element={<PropertyListScreen />}
              />
              <Route
                path="/area-do-corretor/imoveis/listagem"
                element={<PropertyListScreen />}
              />
              <Route
                path="/area-do-corretor/imoveis/listagem/destaques"
                element={<DestaquesScreen />}
              />
              <Route
                path="/area-do-corretor/imoveis/listagem/:listType"
                element={<PropertyListScreen />}
              />
              <Route
                path="/area-do-corretor/imoveis/:id"
                element={<AtuthenticatedDetailsScreen />}
              />
              <Route
                path="/area-do-corretor/clientes/contato"
                element={<FormContactScreen />}
              />
              <Route
                path="/area-do-corretor/clientes/cadastre-seu-imovel"
                element={<PropertyRegisterScreen />}
              />
              <Route
                path="/area-do-corretor/clientes/encomende-seu-imovel"
                element={<PropertyOrderScreen />}
              />
              <Route
                path="/area-do-corretor/usuarios/listagem"
                element={<UserListScreen />}
              />
              <Route
                path="/area-do-corretor/clientes/contato/:id"
                element={<ContactDetailScreen />}
              />
              <Route
                path="/area-do-corretor/clientes/cadastre-seu-imovel/:id"
                element={<RegistrationFormDetailScreen />}
              />

              <Route
                path="/area-do-corretor/clientes/encomende-seu-imovel/:id"
                element={<OrderPropertyDetailScreen />}
              />

              <Route
                path="/area-do-corretor/usuarios/novo"
                element={<UserRegisterScreen />}
              />

              <Route
                path="/area-do-corretor/usuarios/:id"
                element={<UserEditScreen />}
              />

              {/* Configurações */}
              <Route
                path="/area-do-corretor/configuracoes/usuarios"
                element={<ConfigUsersScreen />}
              />
              <Route
                path="/area-do-corretor/configuracoes/cadastrar-usuarios"
                element={<ConfigUsersCreateScreen />}
              />
              <Route
                path="/area-do-corretor/configuracoes/caracteristicas"
                element={<ConfigCategoriesScreen />}
              />
              <Route
                path="/area-do-corretor/configuracoes/tipos-de-imoveis"
                element={<ConfigPropertyTypesScreen />}
              />
              <Route
                path="/area-do-corretor/configuracoes/codigo-de-imovel"
                element={<ConfigPropertyCodeScreen />}
              />
              <Route
                path="/area-do-corretor/configuracoes/cidades-atendidas"
                element={<ConfigServedCitiesScreen />}
              />
              <Route
                path="/area-do-corretor/configuracoes/dados-da-empresa"
                element={<ConfigCompanyDataScreen />}
              />
              <Route
                path="/area-do-corretor/configuracoes/chaves"
                element={<ConfigKeysScreen />}
              />
              <Route
                path="/area-do-corretor/configuracoes/condicoes"
                element={<ConfigConditionsScreen />}
              />
            </>
          )}
        </>
      )}
      {/* 404 redirect to home */}
      <Route
        path="*"
        element={<Navigate to={isAuthenticated ? '/area-do-corretor' : '/'} />}
      />
    </Routes>
  );
};

export default AppRoutes;
